
import { Options, Vue } from "vue-class-component";
import SvgIcon from "@/components/ui/BaseIcons/SvgIcon.vue";

@Options({
  name: "StoreBtn",
  components: {
    SvgIcon,
  },
})
export default class StoreBtn extends Vue {
  private onClickAction(): void {
    this.$router.push({ path: "/cart" });
  }
}
